import { useState, useEffect, useCallback } from "react";
import { Link } from 'react-router-dom';
import { Row, Col, Button, Spin, message, Form, Input, Radio } from 'antd';
import { patientsService } from "../../services/patient";
import Cookies from "universal-cookie";
import { getCookie } from '../../services/cookies';
import { normalizeDocumentNumber } from "../../utils/inputValidations";
import { useTranslation } from 'react-i18next';

const { format } = require('rut.js')

const PatientsPage = () => {
  const [loading, setLoading] = useState(false);
  const [patients, setPatients] = useState();
  const [pagination, setPagination] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [departmentId, setDepartmentId] = useState();
  const [searchCriteria, setSearchCriteria] = useState();
  const [form] = Form.useForm();
  const countryCode = getCookie("country_code");
  const { t } = useTranslation();

  const fetchPatientsList = useCallback(async (params) => {
    setLoading(true);
    const response = await patientsService.getPatientByQuery(params);
    setPatients(response.data);
    setPagination(response.pagination);
    setLoading(false);
  }, [searchCriteria, currentPage]);


  useEffect(() => {
    const cookie = new Cookies();
    const departmentIdCookie = cookie.get('department_id');
    setDepartmentId(departmentIdCookie);

    const params = { page: currentPage, query: searchCriteria };

    if (searchCriteria) {
      fetchPatientsList({ ...params, ...searchCriteria });
    } else {
      fetchPatientsList(params);
    }
  }, [fetchPatientsList]);


  const loadMore = async (event) => {
    const direction = event.target.value;
    const _currentPage = direction === 'next' ? currentPage + 1 : currentPage - 1;
    setCurrentPage(_currentPage);
  };

  const removeFilter = () => {
    setCurrentPage(1);
    setSearchCriteria();
    form.resetFields();
  };

  const onFinish = async (values) => {
    try {
      let queryParams = {
        name: normalizeDocumentNumber(values.query),
        department_id: departmentId
      };

      const paramValues = Object.fromEntries(
        Object.entries(queryParams).filter(([_, values]) => values !== undefined || values !== "")
      );

      if (Object.values(paramValues).length > 0) {
        setSearchCriteria(paramValues);
      } else {
        setSearchCriteria();
      }
      setCurrentPage(1);

    } catch (err) {
      console.error('Error interno.', err);
      message.error('Error interno. Inténtalo de nuevo', err);
    }
  };


  const customTableHeader = () => {
    return (
      <Row className="table-header">
        <Col
          lg={8}
          className="align-item-center-start p-10"
        >
          <h3>Nombre</h3>
        </Col>
        <Col
          lg={8}
          className="center-item p-10"
        >
          <h3 className="text-center">Apellido</h3>
        </Col>
        <Col
          lg={5}
          className="center-item p-10"
        >
          <h3 className="text-center">Identificador</h3>
        </Col>
        <Col
          lg={3}
          className="center-item p-10"
        />
      </Row>
    );
  };

  const customTableBody = (item, index) => {
    return (
      <Row className="table-body mb-15" key={index}>
        <Col
          lg={8}
          xs={12}
          className="align-item-center-start p-10"
        >
          <h3 className="hide-desktop text-center">Nombre</h3>
          <p className="mb-0">{item.names}</p>
        </Col>
        <Col
          lg={8}
          xs={12}
          className="center-item p-10"
        >
          <h3 className="hide-desktop text-center">Apellido</h3>
          <p className="mb-0">{item.last_name}</p>
        </Col>
        <Col
          lg={5}
          xs={12}
          className="center-item p-10"
        >
          <h3 className="hide-desktop text-center">Identificador</h3>
          {
            item.document_type === 'rut' ?
              <p className="text-center mb-0">{format(item.document_number)}</p>
            :
              <p className="text-center mb-0">{item.document_number}</p>
          }
        </Col>
        <Col
          lg={3}
          xs={12}
          className="center-item p-10"
        >
          <Link to={`/pacientes/${item.id}/ver`}>
            <Button className="cmt-button secondary" type="primary" size="small">
              Ver más
            </Button>
          </Link>
        </Col>
      </Row>
    );
  };



  return (
    <Row justify="center" className="patients-search-wrapper">
      <Col lg={22} xs={22}>
        <Row justify="center">
          <Col lg={24} xs={24}>
            <h1 className="mt-30 mb-10">
              {t('patientPage.patientsPage.patients')}
            </h1>
          </Col>
          <Col lg={24} xs={24}>
            <Row justify="space-between">
              <Col lg={18} xs={24}>
                <Form
                  form={form}
                  onFinish={onFinish}
                  size="large"
                >
                  <Row gutter={[15, 10]}>
                    <Col lg={11} xs={24}>
                      <Form.Item name="query">
                        <Input
                          className="cmt-input"
                          placeholder={t('patientPage.patientsPage.queryPlaceholder')}
                        />
                      </Form.Item>
                    </Col>
                    <Col lg={4} xs={24}>
                      <Button
                        className="cmt-button primary"
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                      >
                        <i className="icon-system-search mr-10" />
                        Buscar
                      </Button>
                    </Col>
                    <Col lg={3} xs={24}>
                      <Button
                        onClick={removeFilter}
                        className="cmt-button primary non-outline"
                        type="primary"
                        style={{ boxShadow: 'none' }}
                      >
                        Borrar filtro
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Col>
              <Col lg={5} xs={24}>
                {/* <Link to="/examenes/agregar">
                  <Button
                    className="cmt-button primary"
                    type="primary"
                    size="large"
                    block

                  >
                    <i className="icon-system-plus mr-10" />
                    Ingresar reevaluación
                  </Button>
                </Link> */}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col lg={19} xs={24} className="mt-20 mb-20">
            <Spin
              spinning={loading}
              className="cmt-spin"
            >
            {
              patients ?
                <>
                  {customTableHeader()}
                  {
                    patients.map((item, index) => {
                      return (
                        <>
                          {customTableBody(item, index)}
                        </>
                      )
                    })
                  }
                </>
              :
                <p className="text-center">
                  {t('patientPage.patientsPage.disclaimer')}
                </p>
            }
            </Spin>
          </Col>
        </Row>
        {
          pagination && patients &&
          <Row className="mt-30 mb-50">
            <Col>
              <Radio.Group className="cmt-pagination">
                <Radio.Button
                  value="prev"
                  disabled={currentPage === 1}
                  onClick={loadMore}
                >
                  Anterior
                </Radio.Button>
                <Radio.Button
                  value="next"
                  disabled={patients === null || patients.length < pagination.perPage}
                  onClick={loadMore}
                >
                  Siguiente
                </Radio.Button>
              </Radio.Group>
            </Col>
            <Col className="ml-20" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <p className="mb-0">{pagination.from + 1} - {pagination.to} de {pagination.total}</p>
            </Col>
          </Row>
        }
      </Col>
    </Row>
  );
};

export default PatientsPage;